<template>
  <Modal @close="$emit('close')" :title="title">
    <div slot="body" class="row">
      <div class="col-8 mx-auto">
        <table class="table elevation-1" v-if="books.length">
          <thead class="text-logo">
            <tr>
              <th>Libros</th>
              <th>Estudiantes</th>
            </tr>
          </thead>
          <tbody class="text-primary">
            <template v-for="(book, i) in books">
              <tr :key="i">
                <td>{{ book.title }}</td>
                <td>
                  <button
                    class="button mx-auto my-0"
                    :class="{
                      'default text-secondary': i != activeStudentList,
                      secondary: i == activeStudentList,
                    }"
                    @click="showStudents(i)"
                  >
                    Ver estudiantes
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <div class="row" v-else>
          <div class="col text-center text-gray">
            <span>
              No existen datos para mostrar
            </span>
          </div>
        </div>
      </div>
      <div
        v-if="activeStudentList >= 0 && books[activeStudentList].readers"
        class="col-4 mx-auto"
      >
        <table class="table elevation-1">
          <thead class="text-logo">
            <tr>
              <th>Nombre</th>
            </tr>
          </thead>
          <tbody class="text-primary">
            <template v-for="(student, i) in books[activeStudentList].readers">
              <tr :key="i">
                <td>
                  {{ student.firstname }}
                  {{ student.lastname }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";

export default {
  name: "CurrentReadingBooks",
  components: {
    Modal,
  },
  props: ["data"],
  data() {
    return {
      activeStudentList: -1,
      title: "Libros Actualmente en Lectura",
      books: [],
    };
  },
  methods: {
    showStudents(i) {
      if (this.activeStudentList == i) i = -1;
      this.activeStudentList = i;
    },
  },
  mounted() {
    this.books = this.data;
  },
};
</script>
